import React from 'react';
import ShiftDefinitionManagement from '../components/ShiftDefinitionManagement';

const ShiftDefinitionsPage: React.FC = () => {
  return <ShiftDefinitionManagement />;
};

export default ShiftDefinitionsPage;
